/**
 * Created by Vladislav on 25.09.2024.
 */

// eslint-disable-next-line
var hiddenByDefault = function () {
    const scenes = [cleverapps.Environment.SCENE_OCTOPUS_HUNT];

    if (["match3"].includes(cleverapps.config.type)) {
        scenes.push(cleverapps.Environment.SCENE_GAME);
    }

    return scenes;
};

const SoftMenuBarItem = {
    name: "CoinsItem",
    targets: "soft",
    isClickable: function () {
        return cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_DISABLED;
    },
    plusButton: true,
    value: function () {
        return cleverapps.user.soft;
    },
    updater: function (f) {
        cleverapps.user.on("changeSoft", f, this);
    },
    attentionUpdater: function (f) {
        cleverapps.adsLimits.on("update", f, this);
    },
    attention: function () {
        return false;
    },
    onClickWindow: () => SoftCurrencyShopWindow,
    icon: bundles.menubar.frames.coin_png,
    force: Forces.MENU_BAR_SOFT_FORCE,
    availableOnScenes: function () {
        return [
            cleverapps.Environment.SCENE_MAIN,
            cleverapps.Environment.SCENE_GAME,
            cleverapps.Environment.SCENE_OCTOPUS_HUNT
        ];
    },
    hiddenByDefault: hiddenByDefault(),
    sparks: true,
    incEffect: "meta.coins.collect",
    decEffect: "meta.coins.collect",
    onDebugClick: function () {
        cleverapps.user.setSoft(cleverapps.user.soft + 100, false, { event: cleverapps.EVENTS.EARN.OTHER });
    }
};
